import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3505c18c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ad" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "close" }

import { computed, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  props: {
    options: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    options: {
        resolve: Function,
        reject: Function,
        data: any,
    },
}

const store = useStore()



const temp = reactive({
    cold: 0,
})



onMounted(() => {
    if (props.options.data.times > 0) {
        temp.cold = props.options.data.times
        onTimer()
    }
})

function onTimer() {
    temp.cold--
    if (temp.cold > 0) {
        setTimeout(onTimer, 1000);
    } else {
        onClose()
    }
}

function onClose() {
    emits('close')
}

function onGogo() {
    const url = props.options.data.image_url
    let a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.click()
    onClose()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.options.data.image_src,
      onClick: onGogo
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref(temp).cold) + "秒后自动关闭 ", 1),
      _createElementVNode("a", {
        class: "icon i-guanbi",
        onClick: onClose
      })
    ])
  ]))
}
}

})